export enum AgentMessageSeverity {
    Alert ,
    Critical,
    Warning,
    Information,
    Normal
}
